import { connect } from 'react-redux'

import { getCurrentUser } from '@selectors/data/user_selectors.js'
import { getGroup } from '@selectors/data/group_selectors.js'

import { clientActions } from '../actions/index.js'
import { getCurrentPage, getPagination } from '../reducers/index.js'
import IndexTab from '../components/index_tab.jsx'

const { loadGroupTimelines, paginateTo } = clientActions

const mapStateToProps = (state, props) => {
  const currentUser = getCurrentUser(state, props)
  const group = getGroup(state, props)
  const currentPage = getCurrentPage(state, props)
  const pagination = getPagination(state, {
    groupId: group.id,
    page: currentPage,
  })
  return {
    currentUser,
    pagination,
    group,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    loadData: (pageNumber, groupId) => {
      dispatch(loadGroupTimelines(pageNumber, groupId))
    },
    onPaginate: (pageNumber, groupId) => {
      dispatch(loadGroupTimelines(pageNumber, groupId))
      dispatch(paginateTo(pageNumber, groupId))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IndexTab)
